import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-confirm.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ConfirmIcon = createSvgIcon(<Icon />, 'ConfirmIcon');
